<template>
  <div class="page">
    <el-pagination v-if="pageConfig.total > 0"
      prev-text ="<上一页"
      next-text ="下一页>"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageConfig.currentPage"
      :page-size="pageConfig.pageSize"
      layout="prev,total,next"
      :pager-count = 5 
      :total="pageConfig.total">
    </el-pagination>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  props: ['pageConfig'],
  methods: {
    handleCurrentChange (val) {
      this.$emit('currentPage', Number(val))
    },
    handleSizeChange (val) {
      this.$emit('pageSize', Number(val))
    }
  }
}
</script>
<style lang="less" scoped>
  .page .el-pagination {
    margin-top: 10px;
    text-align: right;
  } 
</style>
